import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import DashBoard from "./Pages/DashBoard/index";
import AddNewUser from "./Pages/AddNewUser";
import RouteGuard from "./Wrappers/RouteGuard";
import SalesPersonGrid from "./Components/SalesPersonGrid";
import CustomerGrid from "./Pages/CustomerGrid";
import { QueryClient, QueryClientProvider } from "react-query";
import { NotifyContainer } from "./Utils/toastify";
import CreateProvider from "./Components/CreateProvider";
import CreateTool from "./Components/CreateTool";
import ViewProvider from "./Components/ViewProvider";
import ViewTools from "./Components/ViewTool";
import LoginOtp from "./Pages/Login-otp";
import OtpVerify from "./Pages/OtpVerify";
import UserProfile from "./Pages/UserProfile/index";
import KycDetails from "./Pages/KycDetails/index";
import MarketUpdate from "./Pages/MarketUpdate/index";
import StartPage from "./Pages/StartPage";
import CreateCollectionRequest from "./Pages/CreateCollectionRequest/index";
import CollectionRequestTemplate from "./Pages/CollectionRequestTemplate/index";
import FeatureFlip from "./Pages/FeatureFlip/index";
import ProjectLayout from "./Pages/FeatureFlip/ProjectLayout";
import ProjectFeatures from "./Pages/FeatureFlip/ProjectFeatures";
import ProjectSegments from "./Pages/FeatureFlip/ProjectSegments";
import FeatureDetails from "./Pages/FeatureFlip/FeatureDetails";

const queryClient = new QueryClient();

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Navigate to="/start" />,
    },
    {
      path: "/dashboard",
      element: (
        <RouteGuard>
          <DashBoard />
        </RouteGuard>
      ),
      children: [
        {
          index: true,
          element: <SalesPersonGrid />,
        },
        {
          path: "customers",
          element: <CustomerGrid />,
        },
        {
          path: "add-another-user",
          element: <AddNewUser />,
        },
      ],
    },
    {
      path: "/provider",
      element: (
        <RouteGuard>
          <DashBoard />
        </RouteGuard>
      ),
      children: [
        {
          path: "create",
          element: <CreateProvider />,
        },
        {
          path: "tool/create",
          element: <CreateTool />,
        },
        {
          path: "view",
          element: <ViewProvider />,
        },
        {
          path: "tool/view",
          element: <ViewTools />,
        },
      ],
    },
    {
      path: "/user-correction",
      element: (
        <RouteGuard>
          <DashBoard />
        </RouteGuard>
      ),
      children: [
        {
          path: "user-profile",
          element: <UserProfile />,
        },
        {
          path: "kyc-details",
          element: <KycDetails />,
        },
        {
          path: "market-update",
          element: <MarketUpdate />,
        },
      ],
    },
    {
      path: "/dam",
      element: (
        <RouteGuard>
          <DashBoard />
        </RouteGuard>
      ),
      children: [
        {
          path: "collection-request-template",
          element: <CreateCollectionRequest />,
        },
        {
          path: "create-request-collection",
          element: <CollectionRequestTemplate />,
        },
        {
          path: "edit-request-collection",
          element: <CollectionRequestTemplate />,
        },
      ],
    },    
    {
      path: "/login-email",
      element: <LoginOtp />,
    },
    {
      path: "/otp-verify",
      element: <OtpVerify />,
    },
    {
      path: "/start",
      element: (
        <RouteGuard>
          <DashBoard />
        </RouteGuard>
      ),
      children: [
        {
          index: true,
          element: <StartPage />,
        },
      ],
    },
    {
      path: "/feature-flip",
      element: (
        <RouteGuard>
          <DashBoard />
        </RouteGuard>
      ),
      children: [
        {
          index: true,
          element: <FeatureFlip />,
        },
        {
          path: "project/:id",
          element: <ProjectLayout />,
          children: [
            { path: "features", element: <ProjectFeatures /> },
            { path: "features/:featureId", element: <FeatureDetails /> },
            { path: "segments", element: <ProjectSegments /> },
          ],
        },
      ],
    },
  ]);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <NotifyContainer />
    </QueryClientProvider>
  );
}

export default App;
